module.exports = __webpack_public_path__ + "static/media/rightdesk-logo-full.cd43059f.svg";